import { useRouter } from 'next/router';
import { CATEGORY_SLUG_TO_API_NAME } from '../i18n/categorySlugMapping';

/**
 * A custom React hook that extracts the current category API syntax from the URL pathname.
 * Handles every product category page name in every language using the mapping from pathTranslations.js.
 *
 * @returns {string} The API syntax representation of the current category based on the URL pathname
 */
export function useCurrentCategoryApiSyntax() {
  const { pathname } = useRouter();
  const pathNameParts = pathname.split('/');
  const urlCategory = pathNameParts[2] ?? '';
  // Map the slug to the canonical API category name
  const categoryApiName = CATEGORY_SLUG_TO_API_NAME[urlCategory] ?? '';
  return categoryApiName;
}
